import { useState } from 'react';
import {Container, Row, Col, Nav, Navbar} from 'react-bootstrap';
import { Link } from "react-router-dom";
import Logo from "../assets/images/logo/logo-transparent.png";
import LogoText from "../assets/images/logo/logotext.png";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGripLines } from '@fortawesome/free-solid-svg-icons';
import Offcanvas from 'react-bootstrap/Offcanvas';

function LandingPageNavbar() {

    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    return (
        <>
            <Navbar expand="" className="fixed-top py-4">
                <Container>
                    <button className="btn border-0 text-light" onClick={handleShow}><FontAwesomeIcon icon={faGripLines} /></button>
                    <Navbar.Brand><Link to="/"><img src={Logo} width="200" /></Link></Navbar.Brand>
                </Container>
            </Navbar>

            <Offcanvas 
                show={show} 
                onHide={handleClose}
                 className="custom-offcanvas"
            >
                <Offcanvas.Header closeButton className="p-4">
                </Offcanvas.Header>
                <Offcanvas.Body className="d-flex flex-column align-items-center justify-content-center">
                    <div className="w-100 text-start mt-5">
                        <Nav className="flex-column ps-3 mt-5 text-small text-uppercase">
                            {/* <Nav.Link> */}
                            <Link to="/shop" className="text-decoration-none text-dark mb-3">Shop</Link>
                            <Link to="/alteration" className="text-decoration-none text-dark mb-3">Alteration</Link>
                            {/* </Nav.Link> */}
                            {/* <Nav.Link> */}
                            <Link to="/about" className="text-decoration-none text-dark mb-3">About</Link>
                            {/* <Link to="/book-appointment" className="btn btn-dark text-decoration-none text-small rounded-0 mb-3">Book an Appointment</Link> */}
                            {/* </Nav.Link> */}
                        </Nav>
                    </div>
                    <Row className="mt-auto mb-4">
                        <Col className="d-flex justify-content-center">
                        <img src={LogoText} width="200" alt="Logo Text" /></Col>
                    </Row>
                </Offcanvas.Body>
            </Offcanvas>
        </>
    );
}

export default LandingPageNavbar;